var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.5 4.5C36.5 6.75 34.625 8.5 32.5 8.5C30.25 8.5 28.5 6.75 28.5 4.5C28.5 2.375 30.25 0.5 32.5 0.5C34.625 0.5 36.5 2.375 36.5 4.5ZM32.5 56.5C34.625 56.5 36.5 58.375 36.5 60.5C36.5 62.75 34.625 64.5 32.5 64.5C30.25 64.5 28.5 62.75 28.5 60.5C28.5 58.375 30.25 56.5 32.5 56.5ZM64.5 32.5C64.5 34.75 62.625 36.5 60.5 36.5C58.25 36.5 56.5 34.75 56.5 32.5C56.5 30.375 58.25 28.5 60.5 28.5C62.625 28.5 64.5 30.375 64.5 32.5ZM8.5 32.5C8.5 34.75 6.625 36.5 4.5 36.5C2.25 36.5 0.5 34.75 0.5 32.5C0.5 30.375 2.25 28.5 4.5 28.5C6.625 28.5 8.5 30.375 8.5 32.5ZM12.625 48.375C14.875 48.375 16.625 50.125 16.625 52.375C16.625 54.625 14.875 56.375 12.625 56.375C10.375 56.375 8.625 54.625 8.625 52.375C8.625 50.125 10.375 48.375 12.625 48.375ZM52.25 48.375C54.5 48.375 56.25 50.125 56.25 52.375C56.25 54.625 54.5 56.375 52.25 56.375C50 56.375 48.25 54.625 48.25 52.375C48.25 50.125 50 48.375 52.25 48.375ZM12.625 8.75C14.875 8.75 16.625 10.5 16.625 12.75C16.625 15 14.875 16.75 12.625 16.75C10.375 16.75 8.625 15 8.625 12.75C8.625 10.5 10.375 8.75 12.625 8.75Z",
    fill: "#1066A8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoader);
export default __webpack_public_path__ + "static/media/loader.6a79a4a6.svg";
export { ForwardRef as ReactComponent };